import { mappingFieldsForArticle } from "./ConstantExport";

export const applyFilter = (data, filters, parentLogic = 'and') => {
    if (!filters || !filters.length === 0) return data;

    return data?.filter((item) => {

        const groupMatches = filters.map((filterGroup) => {
            const groupLogic = filterGroup.logic || 'and';
            const groupFilters = filterGroup.filters || [];

            const matchingData = groupFilters.map((filter) => {
                return applyCondition(item, filter);
            })

            if (groupLogic === "and") {
                return matchingData?.every(Boolean);
            }
            else if (groupLogic === "or") {
                return matchingData?.some(Boolean)
            }
            return false;
        })

        if (parentLogic === 'and') {
            return groupMatches.every(Boolean);  // All groups must match
        } else if (parentLogic === 'or') {
            return groupMatches.some(Boolean);  // At least one group must match
        }
    })

}
export const applySort = (data, sortConfig) => {
    return [...data].sort((a, b) => {
        for (let { field, dir } of sortConfig) {
            const valueA = a[field];
            const valueB = b[field];

            //check every field is string
            if (valueA === null) valueA = ""
            if (valueB === null) valueB = ""
            // Convert numeric strings to numbers for correct comparison
            const numA = !isNaN(valueA) && valueA !== "" ? Number(valueA) : null;
            const numB = !isNaN(valueB) && valueB !== "" ? Number(valueB) : null;
            let comparison = 0;
            if (numA !== null && numB !== null) {
                comparison = numA - numB
            }
            else if (typeof valueA === "string" && typeof valueB === "string") {
                comparison = valueA.localeCompare(valueB,undefined,{numeric:true})
            }
            else {
                comparison = valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
            }
            if (comparison !== 0) {
                return dir === 'asc' ? comparison : -comparison
            }
        }
        return 0;
    })
}

export const applyCondition = (item, filter) => {
    const { field, operator, value } = filter;
    const itemValue = item[field];



    const normalizedItemValue = itemValue?.toString().toLowerCase() || '';
    const normalizedValue = value?.toLowerCase() || '';

    switch (operator) {
        case "contains":
            return normalizedItemValue.includes(normalizedValue) ? item : false;
        case "doesnotcontain":
            return !normalizedItemValue.includes(normalizedValue) ? item : false;
        case "eq":
            if (itemValue && typeof itemValue === 'number' && itemValue === Number(value)) {
                return item
            }
            else if (itemValue && normalizedItemValue === normalizedValue) {
                return item
            }
            else {
                return false;
            }

        case "neq":
            if (itemValue && typeof itemValue === "number" && itemValue !== Number(value)) {
                return item
            }
            else if (itemValue && normalizedItemValue !== normalizedValue) {
                return item
            }
            else {
                return false;
            }
        case "startswith":
            return normalizedItemValue.startsWith(normalizedValue) ? item : false;
        case "endswith":
            return normalizedItemValue.endsWith(normalizedValue) ? item : false;
        case "isnull":
            return itemValue === null || itemValue == undefined ? item : false;
        case "isnotnull":
            return itemValue !== null && itemValue !== undefined ? item : false;
        case "isempty":
            return itemValue === "" || itemValue === null || itemValue === undefined ? item : false;
        case "isnotempty":
            return itemValue !== "" && itemValue !== null && itemValue !== undefined ? item : false;
        default:
            console.warn(`Unsupported operator: ${operator}`);
            return false;
    }
};


export const flatternGroup = (groupData) => {
    if (groupData === undefined || groupData === null) return;

    const flattern = (items, parentGroup = '') => {

        return items?.flatMap((item) => {
            const groupName = parentGroup ? `${parentGroup} > ${item.value}` : item.value;
            if (item.items) {
                return flattern(item.items, groupName)
            }
            else {

                return { ...item, groupName }
            }
        })
    }
    return flattern(groupData)
}


export const formatDate = (date) => {
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ` +
        `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
};


//get current date in dd/mm/yyyy format
export const getTodayDate = () => {
    const today = new Date();

    // Format the date as YYYY-MM-DD
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');

    // Construct the file name
    return `${year}-${month}-${day}`;
}

export const transFormVehicleData = (vehicleData) => {
    return vehicleData.map(row => {
        const newRow = {}
        Object.keys(row).forEach(key => {
            const mappingHeader = mappingFieldsForArticle[key]?.value || key;
            newRow[mappingHeader] = row[key]
        })
        return newRow;
    })
}